export enum PlayerAccountStatus {
  LINKED = 'linked',
  INVITED = 'invited',
  EXPIRED = 'expired',
  NONE = 'none',
}
